/**
 * Utilitário que desabilita console.log, console.warn e console.info em produção
 * 
 * Basta importar este arquivo uma vez na inicialização da aplicação:
 * import './utils/disableConsole';
 */

// Verifica se o ambiente é de produção
const isProduction = (): boolean => {
  // Verificar NODE_ENV do Node.js
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'production') {
    return true;
  }
  
  // Verificar ambiente Vite/React
  if (typeof import.meta !== 'undefined') {
    // Vercel com Vite geralmente define estas variáveis
    if (import.meta.env?.PROD === true || import.meta.env?.MODE === 'production') {
      return true;
    }
    
    // Verificar se há variáveis específicas da Vercel
    if (import.meta.env?.VITE_VERCEL_ENV === 'production') {
      return true;
    }
  }
  
  // Verificar variáveis específicas da Vercel no objeto window
  if (typeof window !== 'undefined') {
    if ((window as any).__VERCEL_PROD_ENV__ || 
        (window as any).VERCEL_ENV === 'production') {
      return true;
    }
  }
  
  // Forçar desativação dos logs para teste
  // Descomente para testar a desativação dos logs, mesmo em desenvolvimento
  // return true;
  
  // Log apenas em desenvolvimento
  if (typeof import.meta !== 'undefined' && !import.meta.env?.PROD) {
    console.log('Ambiente de desenvolvimento detectado. Logs habilitados.');
  }
  
  return false;
};

// Armazena referências originais das funções de console
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug
};

// Aplica a desativação dos logs em produção
if (isProduction()) {
  // Desativa todos os logs sem gerar nenhum log de diagnóstico
  // Sobrescreve TODOS os métodos do console, independentemente do conteúdo
  console.log = function() {};
  console.warn = function() {};
  console.info = function() {};
  console.debug = function() {};
  
  // Mantém apenas console.error para diagnóstico
  // Se quiser desativar também, descomente a linha abaixo:
  // console.error = function() {};
}

// Função para restaurar o comportamento original do console (útil para testes)
export const restoreConsole = (): void => {
  console.log = originalConsole.log;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  console.info = originalConsole.info;
  console.debug = originalConsole.debug;
};

// Função para desabilitar completamente todos os logs, inclusive console.error
export const disableAllConsole = (): void => {
  console.log = function() {};
  console.warn = function() {};
  console.error = function() {};
  console.info = function() {};
  console.debug = function() {};
};

export default { restoreConsole, disableAllConsole }; 